/* jshint esversion: 6 */

import DomService from '../services/dom.service';
import Rect from '../shared/rect';

class ColorsCtrl {
	constructor(
		$scope,
		$timeout,
		$location,
		DomService
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$location = $location; this.domService = DomService; this.onWindowResize = this.onWindowResize.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this); this.onShareKeyDown = this.onShareKeyDown.bind(this);
		this.onWishlistKeyDown = this.onWishlistKeyDown.bind(this);
		this.onViewWishlistKeyDown = this.onViewWishlistKeyDown.bind(this);
		this.navigateToWishlist = this.navigateToWishlist.bind(this);
		window.addEventListener('resize', this.onWindowResize);
		$scope.$on('$destroy', () => {
			window.removeEventListener('resize', this.onWindowResize);
		});
		const hash = this.$location.hash();
		// const search = this.$location.search();
		// console.log(search);
		// if (search.color) {
		if (hash.indexOf('color-') === 0) {
			window.onload = () => {
				setTimeout(() => {
					// const color = document.getElementById(`color-${search.color}`);
					const color = document.getElementById(hash);
					// console.log(color);
					if (color) {
						const colors = Array.prototype.slice.call(document.querySelectorAll('.card--color'));
						const index = colors.indexOf(color);
						if (index !== -1) {
							this.active = index;
							this.onOpen(color, true);
						}
						// color.scrollIntoView();
						// this.scrollIntoView(color);
					}
				}, 150);
			}
		}
	} onKeyDown(event) {
		// Gestisce la navigazione da tastiera per le card colore
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			const target = event.currentTarget;
			const colors = Array.prototype.slice.call(document.querySelectorAll('.group--colors > .card--color'));
			const index = colors.indexOf(target);
			if (index !== -1) {
				// Marca l'evento come navigazione da tastiera per evitare lo scroll
				event.isKeyboardNavigation = true;
				this.onToggle(index, event);
			}
		}
	}
	onShareKeyDown(event) {
		// Gestisce il tasto Enter sul pulsante Share
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			this.$scope.root.share = true;
			this.$scope.$apply();
		}
	}
	onWishlistKeyDown(event, wishlistId) {
		// Gestisce il tasto Enter sui pulsanti wishlist
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			this.$scope.root.wishlistToggle(wishlistId);
			this.$scope.$apply();
		}
	}
	onViewWishlistKeyDown(event, href) {
		// Gestisce il tasto Enter sul pulsante View Wishlist
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			window.location.href = href;
		}
	}

	navigateToWishlist(href) {
		// Gestisce il click sul pulsante View Wishlist
		window.location.href = href;
	}

	scrollIntoView(node) {
		const curtop = (document.body.scrollTop || document.documentElement.scrollTop);
		const top = curtop + node.getBoundingClientRect().top - 200;
		window.scroll(0, top);

		// console.log('ColorsController.scrollIntoView', top);
		DomService.IMMEDIATE_SCROLL = true;
	}

	onWindowResize() {
		const colors = Array.prototype.slice.call(document.querySelectorAll('.group--colors > .card--color'));
		/*
		colors.forEach((x, i) => {
			TweenMax.set(x, { marginBottom: 0, height: 'auto' });
		});
		*/
		if (this.active !== undefined) {
			const color = colors[this.active];
			const detail = color.querySelector('.card__detail');
			if (detail) {
				TweenMax.set(detail, { height: 'auto' });
				const rect = Rect.fromNode(detail);
				TweenMax.set(detail, { left: -color.offsetLeft, height: rect.height });
			}
		}
	}

	onToggle(active, event) {
		if (this.active === active) {
			//this.onClose();
			//this.active = undefined;
			//return;

			const colors = Array.prototype.slice.call(document.querySelectorAll('.group--colors > .card--color'));
			const color = colors[this.active];
			const detail = color.querySelector('.card__detail');
			const classList = event.target.parentNode.classList;
			const classNames = ['btn--share', 'btn--roomvo', 'icon--facebook', 'btn--facebook', 'icon--twitter', 'btn--twitter', 'icon--linkedin', 'btn--linkedin', 'icon--pinterest', 'btn--pinterest', 'icon--remove', 'btn--remove'];

			if ((event.target.parentNode && classNames.some(className => classList.contains(className))) || event.target.classList.contains('group--share') || DomService.isDescendantOf(event.target, detail)) {
				return;
			}

			this.onClose();
			this.active = undefined;
		} else {
			this.active = active;
			// console.log(event.target, event.currentTarget);
			const isKeyboardNav = event && event.isKeyboardNavigation;
			this.onOpen(event.currentTarget, false, isKeyboardNav);
		}
	} onOpen(node, immediate, isKeyboardNavigation = false) {
		const colors = Array.prototype.slice.call(document.querySelectorAll('.group--colors > .card--color'));
		colors.forEach((x, i) => {
			if (i === this.active) {
				x.classList.add('active');
				x.setAttribute('aria-expanded', 'true');
			} else {
				x.classList.remove('active');
				x.setAttribute('aria-expanded', 'false');
				TweenMax.set(x, { marginBottom: 0, height: 'auto' });
			}
		});
		const color = colors[this.active];
		const detail = color.querySelector('.card__detail');
		if (detail) {
			TweenMax.set(detail, { height: 'auto' });
			const rect = Rect.fromNode(detail);
			TweenMax.set(detail, { left: -color.offsetLeft, height: 0, overflow: 'hidden', zIndex: -1 });
			// color.scrollIntoView();
			// Non fare scroll se la navigazione è avvenuta da tastiera
			if (!isKeyboardNavigation) {
				this.scrollIntoView(color);
			}
			if (immediate) {
				TweenMax.set(color, { marginBottom: rect.height });
				TweenMax.set(detail, { height: rect.height, zIndex: 1 });
			} else {
				const from = { value: 0 };
				TweenMax.to(from, 0.6, {
					value: 1,
					overwrite: 'all',
					ease: Power2.easeInOut,
					onUpdate: () => {
						TweenMax.set(color, { marginBottom: rect.height * from.value });
						TweenMax.set(detail, { height: rect.height * from.value });
					},
					onComplete: () => {
						TweenMax.set(detail, { zIndex: 1 });
					}
				});
			}
		}
		if (node.id) {
			const hash = node.id;
			this.$location.hash(hash).replace();
			/*
			const search = {};
			const splitted = node.id.split('-');
			search[splitted[0]] = splitted.length > 1 ? splitted[1] : undefined;
			this.$location.search(splitted[0], splitted[1]).replace();
			*/
			// console.log(node.id, node);
		}
	}
	onClose(immediate) {
		const colors = Array.prototype.slice.call(document.querySelectorAll('.group--colors > .card--color'));
		colors.forEach((x, i) => {
			if (i === this.active) {
				x.classList.add('active');
			} else {
				x.classList.remove('active');
				TweenMax.set(x, { marginBottom: 0, height: 'auto' });
			}
		});
		const color = colors[this.active];
		if (color) {
			color.setAttribute('aria-expanded', 'false');
		}
		const detail = color.querySelector('.card__detail');
		if (detail) {
			TweenMax.set(detail, { height: 'auto' });
			const rect = Rect.fromNode(detail);
			TweenMax.set(detail, { left: -color.offsetLeft, height: rect.height, overflow: 'hidden', zIndex: -1 });
			if (immediate) {
				TweenMax.set(color, { marginBottom: 0 });
				TweenMax.set(detail, { height: 0 });
				color.classList.remove('active');
			} else {
				const from = { value: 1 };
				TweenMax.to(from, 0.6, {
					value: 0,
					overwrite: 'all',
					ease: Power2.easeInOut,
					onUpdate: () => {
						TweenMax.set(color, { marginBottom: rect.height * from.value });
						TweenMax.set(detail, { height: rect.height * from.value });
					},
					onComplete: () => {
						color.classList.remove('active');
					}
				});
			}
		}
	}

}

ColorsCtrl.$inject = ['$scope', '$timeout', '$location', 'DomService'];

export default ColorsCtrl;
